import { v4 as uuidv4 } from "uuid";

export interface LesionEntry {
  lesionId?: string;
  selectedPart: string | null;
  files: any[];
  fileMessages?: string[];
  message?: string;
  anciennete?: string;
  taille?: string;
  douleur?: string;
}

export interface LesionFileMeta {
  lesionId: string;
  bodyPart: string;
  message: string;
  anciennete: string;
  taille: string;
  douleur: string;
}

export const flattenEntries = (
  entries: LesionEntry[]
): (LesionFileMeta & { file: any })[] =>
  entries.flatMap((entry) => {
    const lesionId = entry.lesionId || uuidv4();
    return entry.files.map((file, fileIndex) => ({
      file,
      lesionId,
      bodyPart: entry.selectedPart || "",
      message: entry.fileMessages?.[fileIndex] || "",
      anciennete: entry.anciennete || "",
      taille: entry.taille || "",
      douleur: entry.douleur || "",
    }));
  });

export interface LesionGroup<T> {
  lesionId?: string;
  bodyPart: string;
  anciennete: string;
  taille: string;
  douleur: string;
  items: { file: T; index: number }[];
}

export const groupFilesByLesion = <T extends Record<string, any>>(
  files: T[] = []
): LesionGroup<T>[] => {
  const groups: LesionGroup<T>[] = [];
  const byKey: Record<string, LesionGroup<T>> = {};

  files.forEach((file, index) => {
    if (!file) return;
    const key = file.lesionId
      ? `id:${file.lesionId}`
      : `legacy:${file.bodyPart || ""}|${file.anciennete || ""}|${file.taille || ""}|${file.douleur || ""}`;

    if (!byKey[key]) {
      byKey[key] = {
        lesionId: file.lesionId || undefined,
        bodyPart: file.bodyPart || "",
        anciennete: file.anciennete || "",
        taille: file.taille || "",
        douleur: file.douleur || "",
        items: [],
      };
      groups.push(byKey[key]);
    }
    byKey[key].items.push({ file, index });
  });

  return groups;
};
